import React from 'react'
import { DocumentReportIcon } from '@heroicons/react/outline'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { authenticated } from '../../../recoil/auth'
import { analyticMessage, exportLoading } from '../../../recoil/analytic'
import { domainWeb } from '../../../config/constants'
import WaitingText from '../../WaitingText'
import axios from 'axios'
import moment from 'moment'

const ExportButton = ({contentId}) => {
  const auth = useRecoilValue(authenticated);
  const [loading, setLoading] = useRecoilState(exportLoading);
  const setMessage = useSetRecoilState(analyticMessage);

  const handleExport = async () => {
    setLoading(true);
    setMessage({});

    try {
      let fileUrl = `${domainWeb}/contents/${contentId}/export_excel`;
      const response = await axios.post(fileUrl, null,
        {
          headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Authorization': 'Bearer ' + auth.token
          },
          responseType: 'arraybuffer'
        }
      );
      const winURL = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = winURL;
      const datenow = moment(new Date()).format("DDMMYYYY_HHmmss");
      link.setAttribute('download', `export_${datenow}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setLoading(false);   
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
    
  }

  if (loading) {
    return (
      <button type="button" className="flex items-center justify-center gap-3 px-5 py-3 text-white rounded-lg shadow bg-emerald-500 hover:bg-emerald-600 shadow-blue-100">
        <WaitingText />
      </button>
    )
  } else {
    return (
    <button type="button" onClick={handleExport} className="flex items-center justify-center gap-3 px-5 py-3 text-white rounded-lg shadow bg-emerald-500 hover:bg-emerald-600 shadow-blue-100">
        <DocumentReportIcon className="w-5 h-5" />
        <span>Export Data Excel</span>
    </button>
    )
  }

}

export default ExportButton